<template>
  <div class="page-question">
    <div class="question-container">
      <div class="name">{{ name }}</div>
      <div class="questions">
        <div class="question-item" v-for="(item, i) in questionList" :key="i">
          <div class="title"><span v-if="item.fore === '1'">*</span> {{ item.sort }}. {{ item.title }}({{ item.subjectType | filterType }})</div>
          <div class="options" v-if="item.subjectType === '1' || item.subjectType === '3'">
            <div class="options-item" v-for="(el, k) in item.answerList" :key="k" @click="handleCheck(item, el)">
              <div class="options-item-left">
                <div class="options-item-left-icon">
                  <img v-if="!el.isChoose" src="@/assets/image/check.png" >
                  <img v-else src="@/assets/image/checked.png" >
                </div>
                <div class="options-item-left-text">{{ el.content }}</div>
              </div>
            </div>
          </div>
          <div class="options" v-if="item.subjectType === '2' || item.subjectType === '4'">
            <div class="options-item" v-for="(el, k) in item.answerList" :key="k" @click="handleCheck(item, el)">
              <div class="options-item-left">
                <div class="options-item-left-icon">
                  <img v-if="!el.isChoose" src="@/assets/image/check.png" >
                  <img v-else src="@/assets/image/checked.png" >
                </div>
                <div class="options-item-left-img">
                  <div class="image-item-pics-info" v-for="(ele, j) in el.fileName" :key="j">
                    <img :src="ele.url" height="114rpx" />
                  </div>
                </div>
                <div class="options-item-left-text">
                  {{ el.content }}
                </div>
              </div>
            </div>
          </div>
          <div class="options" v-if="item.subjectType === '5'">
            <textarea type="text" v-model="item.answer" class="options-input"></textarea>
          </div>
          <div class="options" v-if="item.subjectType === '6'">
            <div class="signImg" @click="handleSign(i)">
              <span v-if="!item.signImg">请签名</span>
              <img v-else :src="item.signImg" >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="submit" @click="handleSubmit">提交</div>
    <div class="sign-popup" v-if="signShow">
      <div class="mask"></div>
      <div class="sign-content">
        <vueEsign
          ref="sign"
          :isCrop="isCrop"
          :width="700"
          :height="400"
          :lineWidth="lineWidth"
          :lineColor="lineColor"
          :bgColor.sync="bgColor"
        />
        <div class="sign-btn">
          <div class="sign-btn-item cancel" @click="signCancel">取消</div>
          <div class="sign-btn-item clear" @click="signClear">清空</div>
          <div class="sign-btn-item confirm" @click="signConfirm">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NetService } from '@/service'
import { Toast } from 'vant'
import vueEsign from 'vue-esign'
export default {
  components: { vueEsign },
  data () {
    return {
      questionList: [],
      name: '',
      signShow: false,
      isCrop: false,
      lineWidth: 6,
      lineColor: '#000',
      bgColor: '#fff',
      signIndex: null,
      submitFlag: false,
      starTime: ''
    }
  },
  filters: {
    filterType(type) {
      let str = ''
      switch (type) {
        case '1':
          str = '单选题'
          break
        case '2':
          str = '单选题'
          break
        case '3':
          str = '多选题'
          break
        case '4':
          str = '多选题'
          break
        case '5':
          str = '填空题'
          break
        case '6':
          str = '签名'
          break
        default:
          break
      }
      return str
    }
  },
  created () {
    let query = this.getURLParameters(window.location.href)
    let id = query.id
    this.getQuestion(id)
    this.starTime = new Date()
  },
  methods: {
    async getQuestion(id) {
      let loading = Toast.loading('加载中...')
      try {
        let res = await NetService.getQuestionnaire(`${id}`)
        if (res && res.bankList && res.bankList.length) {
          res.bankList.map(item => {
            if (item.answerList) {
              item.answerList.map(el => {
                if (el.fileName) {
                  el.fileName = JSON.parse(el.fileName)
                }
              })
            }
          })
        }
        this.questionList = res.bankList || []
        this.name = res.name
        this.releaseId = res.id
        this.templateId = res.templateId
        loading.clear()
      } catch(err) {
        loading.clear()
        Toast(err ? err.msg : '')
      }
    },
    getURLParameters(url) {
      return (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
        (a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a), {}
      )
    },
    signCancel() {
      this.signShow = false
      this.signClear()
    },
    signClear() {
      this.$refs.sign.reset()
    },
    signConfirm() {
      this.$refs.sign.generate().then(res => {
        this.questionList[this.signIndex].signImg = res
        this.signShow = false
      }).catch(err => {
        console.log(err)
      })
    },
    handleSign(index) {
      this.signIndex = index
      this.signShow = true
    },
    handleCheck(item, el) {
      if (item.subjectType === '1' || item.subjectType === '3') {
        if (item.subjectType === '3') {
          el.isChoose = !el.isChoose
        } else {
          item.answerList.forEach(ele => {
            if (ele.id === el.id) {
              el.isChoose = true
            } else {
              ele.isChoose = false
            }
          })
        }
      } else if (item.subjectType === '2' || item.subjectType === '4') {
        if (item.subjectType === '4') {
          el.isChoose = !el.isChoose
        } else {
          item.answerList.forEach(ele => {
            if (ele.id === el.id) {
              el.isChoose = true
            } else {
              ele.isChoose = false
            }
          })
        }
      }
      this.$forceUpdate()
    },
    handleSubmit() {
      let message = ''
      for (let i = 0; i < this.questionList.length; i++) {
        if (this.questionList[i].fore === '1') {
          // 必填
          if (this.questionList[i].subjectType === '5') {
            if (!this.questionList[i].answer) {
              message = `选项【${i + 1}】不能为空`
              break
            }
          } else if (this.questionList[i].subjectType === '6') {
            if (!this.questionList[i].signImg) {
              message = `请签名后提交`
              break
            }
          } else {
            let flag = false
            for (let j = 0; j < this.questionList[i].answerList.length; j++) {
              if (this.questionList[i].answerList[j].isChoose) {
                flag = true
                break
              }
            }
            if (!flag) {
              message = `选项【${i + 1}】不能为空`
              break
            }
          }
        }
      }
      if (message) {
        Toast(message)
        return
      }
      const data = {}
      this.questionList.map((item, index) => {
        if (item.subjectType === '5') {
          data[`answer${index + 1}`] = item.answer || ''
        } else if (item.subjectType === '6') {
          data[`answer${index + 1}`] = item.signImg || ''
        } else {
          let answer = []
          item.answerList.map((el) => {
            if (el.isChoose) {
              answer.push(el.id)
            }
          })
          data[`answer${index + 1}`] = answer.join(',')
        }
      })
      console.log(data)
      const endTime = new Date()
      data.useTime = (endTime - this.starTime)  / 1000;  //答题耗时 S秒
      data.releaseId = this.releaseId
			data.templateId = this.templateId
      if (this.submitFlag) {
        Toast('请勿重复提交')
        return
      }
      this.submitFlag = true
      Toast.loading('提交中...')
      NetService.saveQuestionnaire(data).then(() => {
        // this.submitFlag = false
        Toast('提交成功')
      }).catch(err => {
        this.submitFlag = false
        Toast(err ? err.msg : '')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-question {
  min-height: 100vh;
  background: #F6F6F6;
  padding-top: 20px;
  position: relative;
  overflow: auto;
  .question-container {
    background: #fff;
    margin: 0 20px 20px;
    border-radius: 10px;
    padding: 30px;
  }
  .name {
    font-size: 32px;
    color: #000;
    font-weight: 500;
    text-align: center;
  }
  .questions {
    .question-item {
      margin-top: 40px;
      .title {
        font-size: 28px;
        color: #000;
        margin-bottom: 20px;
        span {
          color: rgba(255, 0, 0, 1);
        }
      }
      .options {
        padding: 0 0 0 30px;
        .options-item {
          display: flex;
          align-items: center;
          margin-top: 30px;
          .options-item-left {
            display: flex;
            align-items: center;
            .options-item-left-img {
              margin-right: 10px;
            }
            .options-item-left-icon {
              display: flex;
              margin-right: 15px;
              img {
                width: 30px;
                height: 30px;
              }
            }
            .options-item-left-text {
              font-size: 24px;
              color: #000;
            }
            .image-item-pics-info {
              img {
                width: 120px;
                height: 120px;
              }
            }
          }
        }
        .options-input {
          border: none;
          width: 100%;
          min-height: 30px;
          background: #F6F6F6;
          border-radius: 6px;
          padding: 20px;
          font-size: 24px;
          color: #000;
          display: block;
        }
        .signImg {
          width: 100%;
          background: #f6f6f6;
          display: flex;
          text-align: center;
          padding: 30px;
          span {
            font-size: 22px;
            color: #999;
            text-align: center;
            flex: 1;
          }
          img {
            width: 100%;
          }
        }
      }
    }
  }

  .submit {
    margin: 30px 20px;
    border-radius: 10px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    background: #FF8B5C;
    color: #fff;
    font-size: 32px;
    cursor: pointer;
  }
  .sign-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.5);
      z-index: 10000;
    }
    .sign-content {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      border-radius: 10px;
      padding: 20px;
      z-index: 10001;
      width: 90%;
      .sign-btn {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        .sign-btn-item {
          width: 140px;
          height: 58px;
          line-height: 58px;
          text-align: center;
          border-radius: 6px;
          background: #F6F6F6;
          margin: 0 10px;
          font-size: 24px;
          color: #000;
          cursor: pointer;
          &.cancel {
            background: #F6F6F6;
          }
          &.clear {
            background: rgba(255, 92, 92, 1);
            color: #fff;
          }
          &.confirm {
            background: #3acb7b;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>